import debounce from 'lodash/debounce'
import { StatusBar } from 'react-native'
import { getColourScheme, ColourScheme } from 'APP/Helpers/AppearanceUtils'

// For maping react-navigation statusBarStyle values to react-native StatusBar styles,
// so we don't need to reconfigure when we update expo and remove all of this.
const statusBarStyleMap = {
  [ColourScheme.DARK]: 'dark-content',
  [ColourScheme.LIGHT]: 'light-content',
}

const defaultStyle = getColourScheme() === ColourScheme.DARK ? 'light-content' : 'dark-content'

export const createStatusBarStyleSetter = () => {
  let lastStyle = null

  const setStatusBarStyle = (style) => {
    const newStyle = statusBarStyleMap[style] || defaultStyle
    if (newStyle !== lastStyle) {
      StatusBar.setBarStyle(newStyle, true)
      lastStyle = newStyle
    }
  }

  return debounce(setStatusBarStyle, 100)
}
